// src/pages/NetworkAlerts/constants.js — helpers puros do módulo "Problema Geral"
import { i18n } from "../../translate/i18n";

export const SCOPE_TYPES = ["pon", "olt", "nas", "city", "region"];

// Escopo "Todos os clientes": enviado ao backend como scopeType "all" / scopeValue "*".
export const SCOPE_ALL = "all";
export const SCOPE_ALL_VALUE = "*";

// Campos de topologia que um ERP pode não fornecer (chave = valor de `by`)
export const TOPOLOGY_FIELDS = ["pon", "olt", "nas"];

export const ALERT_FILTERS = ["active", "closed", "all"];

export const scopeTypeLabel = (type) => i18n.t(`networkAlerts.scope.${type}`);

export const scopePlaceholder = (type) =>
  i18n.t(`networkAlerts.scope.placeholder.${type}`);

/** Rótulo curto do escopo de um alerta: "PON 1/2/3", "Cidade Belo Horizonte", "Todos os clientes". */
export const scopeLabel = (scopeType, scopeValue) => {
  if (!scopeType || scopeType === SCOPE_ALL) return i18n.t("networkAlerts.scope.all");
  return `${scopeTypeLabel(scopeType)} ${scopeValue || ""}`.trim();
};

export const isWhatsappConnection = (w) =>
  !w?.channel || String(w.channel).toLowerCase().includes("whatsapp");

export const isOfficialConnection = (w) =>
  String(w?.channel || "").toLowerCase().includes("oficial");

export const isErpIntegration = (it) =>
  ["SGP", "IXC"].includes(String(it?.type || "").toUpperCase());

/**
 * Texto que o bot manda ao cliente:
 * "⚠️ {título}: {mensagem}. Previsão de normalização: {previsão}"
 */
export const buildAlertText = ({ title, message, endsAt }, formatDatetime) => {
  const t = String(title || "").trim();
  const m = String(message || "").trim().replace(/[.!?]+$/, "");
  if (!t && !m) return "";
  const body = t && m ? `${t}: ${m}` : t || m;
  if (endsAt) {
    const when = formatDatetime ? formatDatetime(endsAt) : String(endsAt);
    return i18n.t("networkAlerts.preview.withEnds", { body, endsAt: when });
  }
  return i18n.t("networkAlerts.preview.withoutEnds", { body });
};

const pad = (n) => String(n).padStart(2, "0");

/** Date/ISO → valor de <input type="datetime-local"> no fuso local. */
export const toDatetimeLocal = (value) => {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
};

/** Valor de datetime-local → ISO (ou null se vazio/inválido). */
export const fromDatetimeLocal = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
};

const time = (v) => {
  const t = v ? new Date(v).getTime() : 0;
  return Number.isNaN(t) ? 0 : t;
};

/** Ativos primeiro; dentro de cada grupo, mais recentes no topo. */
export const sortAlerts = (list) =>
  [...list].sort((a, b) => {
    if (!!a.active !== !!b.active) return a.active ? -1 : 1;
    return time(b.startsAt || b.createdAt) - time(a.startsAt || a.createdAt);
  });

export const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};
